import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconRewind = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--rewind")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M10,16.9553606 L10,7.04463936 L3.62882204,12 L10,16.9553606 Z M10.3860594,19.7893522 L1.38605939,12.7893522 C0.871313538,12.3889943 0.871313538,11.6110057 1.38605939,11.2106478 L10.3860594,4.21064778 C11.0429174,3.69975822 12,4.16785182 12,5 L12,19 C12,19.8321482 11.0429174,20.3002418 10.3860594,19.7893522 Z M21,16.9553606 L21,7.04463936 L14.628822,12 L21,16.9553606 Z M21.3860594,19.7893522 L12.3860594,12.7893522 C11.8713135,12.3889943 11.8713135,11.6110057 12.3860594,11.2106478 L21.3860594,4.21064778 C22.0429174,3.69975822 23,4.16785182 23,5 L23,19 C23,19.8321482 22.0429174,20.3002418 21.3860594,19.7893522 Z" id="icon--centivo--rewind"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-277.000000, -1085.000000)"/>
          <g id="Icon/rewind">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--rewind"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--rewind"/>
          </g>
      </g>
  </IconWrapper>
)
